import React from "react";

const NewComerBadge = () => {

    return  (
        <div className="search-hit__badge search-hit__badge--newcomer">Neu</div>
    );
};

export default NewComerBadge;
